/**
 * * Модель сохранения команды
 */
export class SaveTeamModel {
  /**ID неймспейса */
  NamespaceId!: string;
  /**Идентификаторы пользователей в команде */
  UserIds: Array<number> = [];
  RemoveQueueTasksAccess?: boolean;
  RemoveTaskPerformer?: boolean;
  RemoveTaskObserver?: boolean;
  constructor(obj?: Partial<SaveTeamModel>) {
    Object.assign(this, obj);
  }
}
